// extracted by mini-css-extract-plugin
export default {"text":"dictionary_text__Pm-50","listItem":"dictionary_listItem__nLwPc","list":"dictionary_list__5bTJn"};